import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  substitutionPlan?: SduiTypes.substitutionPlan
): OutTypes.exception[] => {
  if (!substitutionPlan) return [];

  const {
    cancellations,
    lesson_changes,
    additionals
  } = substitutionPlan;

  return [
    // ...cancellations.map(
    //   cancellation => ({
    //     ids: cancellation.id
    //   })
    // ),
    // ...lesson_changes.map(
    //   lesson_change => ({
    //     ids: lesson_change.id
    //   })
    // ),
    // ...additionals.map(
    //   additional => ({
    //     ids: additional.id
    //   })
    // )
  ];
};